import React from "react";
import { Link } from "react-router-dom";

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg p-8">
        <div className="mb-8">
          <Link
            to="/login"
            className="text-green-600 hover:text-green-700 font-medium inline-flex items-center"
          >
            <i className="bx bx-arrow-back mr-2"></i>
            Retour à la connexion
          </Link>
        </div>

        <h1 className="text-4xl font-bold text-gray-900 mb-8">
          Conditions d'Utilisation
        </h1>

        <div className="prose prose-lg max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              1. Acceptation des Conditions
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              En accédant et en utilisant l'application La Compassion, vous
              acceptez d'être lié par les présentes Conditions d'Utilisation.
              Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser
              notre service.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              2. Description du Service
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              La Compassion est une application de gestion médicale qui permet
              de :
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Gérer les dossiers patients</li>
              <li>Planifier et suivre les rendez-vous</li>
              <li>Enregistrer les consultations médicales</li>
              <li>Gérer les prescriptions et examens</li>
              <li>Générer des rapports médicaux</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              3. Utilisation du Service
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Vous vous engagez à :
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>
                Utiliser le service uniquement à des fins légales et
                professionnelles
              </li>
              <li>
                Maintenir la confidentialité de vos identifiants de connexion
              </li>
              <li>
                Ne pas partager votre compte avec des tiers non autorisés
              </li>
              <li>
                Respecter toutes les lois et réglementations applicables
              </li>
              <li>
                Ne pas tenter d'accéder à des zones non autorisées du système
              </li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              4. Comptes Utilisateur
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Vous êtes responsable de :
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Maintenir la sécurité de votre compte</li>
              <li>Toutes les activités effectuées sous votre compte</li>
              <li>
                Nous informer immédiatement de toute utilisation non autorisée
              </li>
              <li>
                Fournir des informations exactes et à jour lors de
                l'enregistrement
              </li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              5. Confidentialité Médicale
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Tous les utilisateurs s'engagent à :
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>
                Respecter le secret médical et la confidentialité des données
                patients
              </li>
              <li>
                Ne pas divulguer d'informations médicales à des tiers non
                autorisés
              </li>
              <li>
                Utiliser les données uniquement dans le cadre de leurs fonctions
                professionnelles
              </li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              6. Propriété Intellectuelle
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Tous les contenus, fonctionnalités et logiciels de l'application La
              Compassion sont la propriété de La Compassion ou de ses
              concédants de licence. Vous n'êtes pas autorisé à copier, modifier,
              distribuer ou créer des œuvres dérivées sans autorisation écrite.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              7. Limitation de Responsabilité
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Dans les limites permises par la loi :
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>
                La Compassion ne garantit pas que le service sera ininterrompu
                ou exempt d'erreurs
              </li>
              <li>
                Nous ne sommes pas responsables des décisions médicales prises
                sur la base des informations du système
              </li>
              <li>
                La responsabilité médicale reste celle du professionnel de
                santé utilisateur
              </li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              8. Résiliation
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Nous nous réservons le droit de suspendre ou de résilier votre
              accès au service en cas de violation de ces conditions
              d'utilisation, sans préavis.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              9. Modifications des Conditions
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Nous nous réservons le droit de modifier ces Conditions
              d'Utilisation à tout moment. Les modifications entreront en vigueur
              dès leur publication. Votre utilisation continue du service
              constitue votre acceptation des conditions modifiées.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              10. Droit Applicable
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Ces Conditions d'Utilisation sont régies par les lois en vigueur
              dans votre juridiction. Tout litige sera soumis à la compétence
              exclusive des tribunaux compétents.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              11. Contact
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Pour toute question concernant ces Conditions d'Utilisation,
              veuillez nous contacter à :
            </p>
            <p className="text-gray-700 leading-relaxed">
              <strong>Email :</strong> cabinetcompassion@gmail.com
              <br />
              <strong>Téléphone :</strong> +229 01 98 74 96 96
            </p>
          </section>

          <div className="mt-8 pt-8 border-t border-gray-200 text-sm text-gray-500">
            <p>Dernière mise à jour : {new Date().toLocaleDateString("fr-FR")}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;

